module.exports = __webpack_public_path__ + "img/subBan03.09b2b5fb.jpg";